// src/services/movieApi.js
import axios from "axios";

const apiKey = process.env.REACT_APP_TMDB_API_KEY; // Replace with your TMDB API key

const tmdbBaseUrl = "https://api.themoviedb.org/3";
const popularMoviesEndpoint = "/movie/popular";
const movieDetailsEndpoint = "/movie";

const getPopularMovies = async (page) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}${popularMoviesEndpoint}`,
            {
                params: {
                    api_key: apiKey,
                    page: page,
                },
            }
        );

        return response.data;
    } catch (error) {
        throw new Error("Error fetching popular movies:", error);
    }
};

const getMovieDetails = async (movieId) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}${movieDetailsEndpoint}/${movieId}`,
            {
                params: {
                    api_key: apiKey,
                },
            }
        );

        return response.data;
    } catch (error) {
        throw new Error("Error fetching movie details:", error);
    }
};

const getMovieCredits = async (movieId) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}/movie/${movieId}/credits`,
            {
                params: {
                    api_key: apiKey,
                },
            }
        );

        // Extract the first 5 cast members
        const firstFiveCast = response.data.cast.slice(0, 5);

        return firstFiveCast;
    } catch (error) {
        throw new Error("Error fetching popular movies:", error);
    }
};

const getRecommendedMovies = async (movieId) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}/movie/${movieId}/recommendations`,
            {
                params: {
                    api_key: apiKey,
                },
            }
        );

        const firstFourRecommendedMovies = response.data.results.slice(0, 4);

        return firstFourRecommendedMovies;
    } catch (error) {
        console.error("Error fetching recommended movies:", error);
    }
};

const getSimilarMovies = async (movieId) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}/movie/${movieId}/similar`,
            {
                params: {
                    api_key: apiKey,
                },
            }
        );

        const firstFourSimilarMovies = response.data.results.slice(0, 4);

        return firstFourSimilarMovies;
    } catch (error) {
        console.error("Error fetching similar movies:", error);
    }
};

const getMovieReviews = async (movieId) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}/movie/${movieId}/reviews`,
            {
                params: {
                    api_key: apiKey,
                },
            }
        );

        const firstFiveReviews = response.data.results.slice(0, 5);

        return firstFiveReviews;
    } catch (error) {
        console.error("Error fetching movie reviews:", error);
    }
};

const getMovieSearch = async (searchTerm, page) => {
    try {
        const response = await axios.get(`${tmdbBaseUrl}/search/movie?`, {
            params: {
                api_key: apiKey,
                query: searchTerm,
                page: page,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching search movies: ", error);
    }
};

const getMoviesByGenres = async (genreId, page) => {
    try {
        const response = await axios.get(
            `${tmdbBaseUrl}/discover/movie?&with_genres=${genreId}`,
            {
                params: {
                    api_key: apiKey,
                    page: page,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Failed to fetch movies by this genre: ", error);
    }
};

const getAllGenres = async () => {
    try {
        const response = await axios.get(`${tmdbBaseUrl}/genre/movie/list`, {
            params: {
                api_key: apiKey,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Failed to fetch all genres: ", error);
    }
};

export {
    getPopularMovies,
    getMovieDetails,
    getMovieCredits,
    getRecommendedMovies,
    getSimilarMovies,
    getMovieReviews,
    getMovieSearch,
    getMoviesByGenres,
    getAllGenres,
};
